import { Link, useLocation } from "react-router-dom";

const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/phoonmusic", icon: "instagram" },
  { label: "SoundCloud", href: "https://soundcloud.com/musicbyphoon", icon: "soundcloud" },
  { label: "Spotify", href: "https://open.spotify.com/artist/4DKokEWRuxYx2XItcPgUQe?si=5wsBb6SoRNO6o52UbizzNg", icon: "spotify" },
  { label: "YouTube", href: "https://www.youtube.com/@phoonmusic", icon: "youtube" },
];

const SocialIcon = ({ type }) => {
  switch (type) {
    case "instagram":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-5 h-5">
          <rect x="2" y="2" width="20" height="20" rx="5" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
        </svg>
      );
    case "soundcloud":
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
          <path d="M1 18V14h1v4H1zm2.5-5v5h1v-5h-1zM6 11v7h1v-7H6zm2.5-1v8h1v-8h-1zM11 8v10h1V8h-1zm2.5 1v9h1v-9h-1zM16 7v11h1V7h-1zm2.5 2v9h1V9h-1zM21 10v8h1v-8h-1z" />
        </svg>
      );
    case "spotify":
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
          <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.586 14.424a.623.623 0 01-.857.207c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.215c3.809-.87 7.076-.496 9.712 1.115a.623.623 0 01.207.857zm1.225-2.718a.78.78 0 01-1.072.257c-2.687-1.652-6.785-2.131-9.965-1.166a.78.78 0 01-.452-1.492c3.632-1.102 8.147-.568 11.234 1.329a.78.78 0 01.255 1.072zm.105-2.835C14.692 8.95 9.375 8.775 6.297 9.71a.935.935 0 11-.543-1.79c3.532-1.072 9.404-.865 13.115 1.338a.935.935 0 01-1.053 1.613z" />
        </svg>
      );
    case "youtube":
      return (
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
          <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      );
    default:
      return null;
  }
};

export default function Footer() {
  const location = useLocation();
  if (location.pathname === "/admin") return null;

  return (
    <footer data-testid="footer" className="bg-[#080810] border-t border-[#FF5500]/20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex flex-col items-center md:items-start gap-2">
            <Link to="/" className="font-['Bungee'] text-2xl text-[#F4EFE6]">PHÖÖN</Link>
            <p className="font-mono-label text-xs text-[#F4EFE6]/60">House & Tech House</p>
          </div>

          <div className="flex items-center gap-6">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${social.icon}`}
                className="text-[#F4EFE6]/60 hover:text-[#FF5500] transition-colors duration-300"
                aria-label={social.label}
              >
                <SocialIcon type={social.icon} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-[#FF5500]/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-mono-label text-[10px] text-[#F4EFE6]/50">
            Booking: phoonforbookings@gmail.com
          </p>
          <p className="font-mono-label text-[10px] text-[#F4EFE6]/40">
            &copy; {new Date().getFullYear()} Phöön. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
